<template>
  <div class="context" onselectstart="return false">
    <div class="interface">
      <div class="logo">
        <img src="../assets/img/logo.png" alt="LOGO"/>
        <div class="text-login">
          {{$t("message.sysale")}}
        </div>
      </div>
      <div class="entry" v-on:keydown="keyClick($event)">
        <!--无区号-->
        <!--<el-input class="input" v-model="accountNumber" :placeholder="$t('message.accountNumber')"></el-input>-->
        <!--可选择区号-->
        <el-input class="input" v-model="accountNumber" :placeholder="$t('message.accountNumber')">
          <el-select v-model="ncode" slot="prepend" style="width: 120px" :placeholder="$t('message.pleaseSelect')">
            <el-option v-for="item in areaList" :key="item.ncode" :label="item.area_name" :value="item.ncode">
              <span style="float: left">{{item.area_name}}</span>
              <span style="float: right;padding: 0 10px">+{{item.ncode}}</span>
            </el-option>
          </el-select>
        </el-input>

        <el-input class="input" :type="displayCipher" v-model="password" @keyup.enter.native="mainInterface" :placeholder="$t('message.password')">
          <i slot="suffix" :class="['el-input__icon','pad-lr','iconfont',displayCipher=='password'?'icon-buxianshimima':'icon-xianshimima']" @click="openDisplay"></i>
        </el-input>
        <el-checkbox class="checkbox" v-model="checked">{{$t("message.automaticLogon")}}</el-checkbox>
        <el-button type="primary" class="into" @click="mainInterface" :loading="loginLoading">{{$t("message.login")}}</el-button>
      </div>
    </div>
    <div class="bottomDisplay">
      <p>{{$t("message.technicalSupport")}} | <a style="color:#fff" href="http://beian.miit.gov.cn/" target="_blank">{{$t("message.ICP")}}</a></p>
    </div>
  </div>
</template>

<script>
  import ElButton from "../../node_modules/element-ui/packages/button/src/button";
  export default {
    components: {ElButton},
    data() {
      return {
        accountNumber:'', //账号
        password:'', //密码
        ncode:'', //地区码
        areaList: [], //区域列表
        displayCipher:'password', //显示密码
        checked: false, //自动登录
        loginLoading:false, //登录加载
      }
    },
    created() {
      this.ncode=localStorage.getItem("ncode")==undefined?'':parseFloat(localStorage.getItem("ncode"));
    },
    mounted() {
      this.getCookie(); //读取cookie
      this.getLandingAreas(); //获取登陆区域列表
    },
    methods: {
      //获取登陆区域列表(繁体)
     getLandingAreas() {
       let _this=this;
       _this.axios.post(_this.$store.state.urlHttp+'/xx_admin/user.Login/list_login_area').then(function(res){
//          console.log(res.data);
         if(res.data.ret_status=='ok'){
           _this.areaList=res.data.list_area;
         }
       }).catch(function (error) {
         _this.openErr(_this.$t("message.requestFailure"));
       });
     },
      //获取登陆区域列表(简体)
//       getLandingAreas() {
//         let _this=this;
//         _this.axios.post(_this.$store.state.urlHttp+'/xx_admin/user.Login/list_login_area/cn').then(function(res){
// //          console.log(res.data);
//           if(res.data.ret_status=='ok'){
//             _this.areaList=res.data.list_area;
//           }
//         }).catch(function (error) {
//           _this.openErr(_this.$t("message.requestFailure"));
//         });
//       },
      //登录
      mainInterface() {
        const self = this;
        self.loginLoading=true;
        if(self.ncode==''){
          self.openWar(self.$t("message.chooseNcode"));
          self.loginLoading=false;
          return;
        }
        let obj={
          empAcct:self.accountNumber, //账号
          empPswd:self.password, //密码
          ncode:self.ncode, //区号
        };
        self.axios.post(self.$store.state.urlHttp+'/xx_admin/user.Login/login',obj).then(function(res){
          self.loginLoading=false;
//          console.log(res.data);
          if(res.data.ret_status=='ok'){
            //判断复选框是否被勾选 勾选则调用配置cookie方法
            if (self.checked == true) {
              //传入账号名，密码，和保存天数3个参数
              self.setCookie(self.accountNumber, self.password, 15);
            }else {
              //清空Cookie
              self.clearCookie();
            }
            localStorage.setItem('ncode',self.ncode);
            self.$store.commit('BOSS_LOGIN',res.data);
            self.$router.replace({ path:'/index' });
          }else {
            self.openWar(res.data.rpc_msg)
          }
        }).catch(function (error) {
          self.openErr(self.$t("message.requestFailure"));
          self.loginLoading=false;
        });
      },
      //设置cookie
      setCookie(c_name, c_pwd, exdays) {
        let exdate = new Date(); //获取时间
        exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
        //字符串拼接cookie
        window.document.cookie = "sysaleName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
        window.document.cookie = "sysalePwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
      },
      //清除cookie
      clearCookie() {
        this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
      },
      //读取cookie
      getCookie() {
        if (document.cookie.length > 0) {
          let arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
          for (let i = 0; i < arr.length; i++) {
            let arr2 = arr[i].split('='); //再次切割
            //判断查找相对应的值
            if (arr2[0] == 'sysaleName') {
              this.accountNumber = arr2[1]; //保存到保存数据的地方
            } else if (arr2[0] == 'sysalePwd') {
              this.password = arr2[1];
            }
          }
          if(this.accountNumber==''&&this.password==''){
            this.checked=false;
          }else {
            this.checked=true;
          }
        }
      },
      //回车登录
      keyClick(){
        if(window.event.keyCode==13){
          this.mainInterface();
        }
      },
      //显示密码
      openDisplay() {
        if(this.displayCipher=='password'){
          this.displayCipher='text';
        }else {
          this.displayCipher='password';
        }
      },
    },
  }
</script>

<style lang="less" scoped>
  .context{
    height: 100%;
    background-color: #409EFF;
    overflow: auto;
    display: flex;
    align-items: center;
  }
  .interface{
    width: 450px;
    margin: 0 auto;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 5px 10px rgba(26,26,26,.1);
    box-sizing: border-box;
    .logo{
      text-align: center;
      padding-top: 30px;
      .text-login{
        padding-top: 10px;
        font-size: 20px;
        color: #409EFF;
      }
    }
    .entry{
      padding: 20px 30px;
      .input{
        margin: 10px 0;
        .pad-lr{
          padding: 5px;
        }
        .iconfont{
          font-size: 24px;
        }
      }
      .checkbox{
        margin-top: 10px;
      }
      .into{
        margin: 20px 0;
        width: 100%;
      }
      .forget{
        text-align: center;
      }
    }
  }
  .bottomDisplay{
    background-color: #409EFF;
    width: 100%;
    position: fixed;
    text-align: center;
    bottom: 0;
    left: 0;
    p{
      color: #ffffff;
      padding: 15px;
    }
  }
  .maturing{
    margin: 20px 0;
    text-align: center;
    p{
      font-size: 16px;
      line-height: 36px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/login.vue